import React, { useContext, useEffect, useReducer, useState } from "react";
import Dialog from "@material-ui/core/Dialog";

import {
    createStyles,
    Grid,
    IconButton,
    makeStyles,
    Typography,

} from "@material-ui/core";
import tableIcons, { options } from "components/universal/table_attributes";
import MaterialTable from "material-table";
import { ToastMessageContext } from "lib/contexts/message_context";
import ShiftServices from "lib/services/api/planning/Shifts/shift";
import { getOrganisationId } from "lib/utils/common_utils";

const useStyles = makeStyles((theme) =>
    createStyles({
        modal: {
            "& .MuiDialog-paperWidthSm": {
                minWidth: "750px",
                // height: "110vh"
            },
        },
        container: {
            // minWidth: "1200px",
            // minHeight: "400px",
            padding: "50px",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden !important"
        },

        popupTitle: {
            fontSize: "20px",
            lineHeight: "28px",
            position: "absolute",
            top: "19px",
            bottom: "15px",
            left: "25px",
        },
        divider: {
            borderBottom: `1px solid ${theme.palette.primary.main}`,
        },
        tableTitle: {
            fontSize: "16px",
            lineHeight: "22px",
            color: "#4D4F5C",
            fontWeight: "bold",
            marginTop: "19px",
            marginBottom: "16px",
        },
        tableCell: {
            height: '32px',
            justifyContent: "space-between",
            whiteSpace: "normal",
            wordWrap: "break-word",

        },
    })
);

function LeavePopUp(props) {
    const { handleClose, currentSelection } = props
    const classes = useStyles();
    const message = useContext(ToastMessageContext);
    const [data, setData] = useState([])
    const [Loading, setLoading] = useState(false)


    useEffect(() => {
        setLoading(true)
        let currentData = currentSelection?.this_period.split("-")
        let nextData = currentSelection?.next_period.split("-")
        setData([
            { title: "", value1: <b>{currentData[0]}</b>, value2: <b>{nextData[0]}</b> },
            { title: "Entitlement", value1: currentSelection?.entitlement, value2: currentSelection?.entitlement },
            { title: "Carried Forward", value1: currentSelection?.carry_forward, value2: currentSelection?.next_carry_forward },
            {
                title: "Total", value1: parseInt(currentSelection?.entitlement) + parseInt(currentSelection?.carry_forward), value2: parseInt(currentSelection?.entitlement) + parseInt(currentSelection?.next_carry_forward)
            },
            {
                title: "Leave Accepted", value1: currentSelection?.request_accepted || '-', value2: currentSelection?.next_period_accepted || "-"

            },
            { title: "Leave Pending Approval", value1: currentSelection?.request_pending || "-", value2: currentSelection?.next_period_pending || "-" },
            {
                title: "Remaining", value1: <u>{currentSelection?.this_period_remaining}</u>, value2: <u>{currentSelection?.next_period_remaining}</u>
            },


        ])
        setLoading(false)

    }, [currentSelection])

    const tableOptions = {
        ...options,
        paging: false,
        search: false,
        header: false,
        toolbar: false,
        rowStyle: {
            height: '42px'
        }
    };

    const column = [

        {
            title: "title",
            field: "title",
            width: '60%',
            headerStyle: {
                textAlign: "left",
                paddingLeft: "15px",
                width: '60%',
            },
            cellStyle: {
                textAlign: "left",
                paddingLeft: "15px",
                width: '60%',
            },
        },
        {
            title: "Current Period",
            field: "value1",


        },

        {
            title: "Next Period",
            field: "value2",

        },
    ];





    return (
        <div>
            <Dialog
                open={true}
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={classes.modal}
            >
                <div className={classes.container}>
                    <Typography
                        variant="body1"
                        color="primary"
                        style={{ marginBottom: "20px" }}
                        className={classes.popupTitle}
                    >
                        User Leave Details
                    </Typography>

                    <Grid item xs={6} style={{ marginTop: "10px", }}>
                        <MaterialTable
                            style={{
                                boxShadow: "0px 1px 3px #00000033",
                                borderRadius: "4px",
                                width: "650px",
                                // minWidth: "500px"
                            }}

                            options={tableOptions}
                            title=""
                            icons={tableIcons}
                            columns={column}
                            data={data || []}
                            isLoading={Loading}


                        />
                    </Grid>
                </div>
            </Dialog>

        </div>
    )
}


export default LeavePopUp